let $ = jQuery;
$ = require('../plugins/jquery.sticky.js');
let breakpoints = require('../utilities/breakpoints');

class StickyProfile {

  constructor($card) {

    if (breakpoints.current === 'large' || breakpoints.current === 'xlarge') {
      var offset = $card.offset().top;

      $card.sticky({
        topSpacing: offset
      });
    }
  }
}

module.exports = {
  attach: function(context, settings) {

    var $profileCard = $(".js-sticky-wrap--reg");

    if ($profileCard.length) {
      new StickyProfile($profileCard);
    }
  }
}
